module.exports = {
  you_have_been_challenged: '{playerName} hat dich herausgefordert!',
  its_your_turn: 'Du bist an der Reihe im Spiel gegen {playerName}',
}
